import { Close } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toLowerCase } from '../../../../../constants/commonFunction';
import {
  IRoleObjProps,
  RolesProps,
  useUAM,
} from '../../../../../providers/UAMProvider';
import { NESTED_ROUTES } from '../../../../../router/routes';

interface IProps {
  index: number;
  role: IRoleObjProps;
}

const RoleChip = ({ role, index }: IProps) => {
  const { params } = useParams();
  const { selectedBranch, setSelectedBranch } = useUAM();

  const handleDeleteRole = async (index: number) => {
    const updatedBranches = [...selectedBranch];
    const selectedBranchOptions = updatedBranches[index];
    const roleObj = {
      id: '',
      name: '',
    };
    const newObj = {
      ...selectedBranchOptions,
      roles: roleObj,
      managers: roleObj,
    } as RolesProps;
    updatedBranches.splice(index, 1, newObj);
    setSelectedBranch(updatedBranches);
  };

  return (
    <>
      <Stack
        direction={'row'}
        alignItems={'center'}
        gap={1}
        key={role.id}
        sx={{
          bgcolor: '#3966E2',
          color: 'white',
          borderRadius: '12px',

          px: 1.5,
          py: 0.5,
          fontFamily: `var(--font-Aspekta-600) !important`,
          fontSize: '0.625rem',
        }}
      >
        {toLowerCase(role.name)}
        {params !== NESTED_ROUTES.VIEW_DETAILS && (
          <Close
            sx={{
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleDeleteRole(index);
            }}
          />
        )}
      </Stack>
    </>
  );
};

export default RoleChip;
